//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AApplyForm from '../../../components/AApplyForm.vue';

export default {
  name: "NewDesignJob",
  commponents: { AApplyForm },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    heroBlock() {
      return {
        hidden: this.data.attributes.hidden || false,
        pretitle: this.data.attributes.location_job || "",
        title: this.data.attributes.title_job || "",
        text: this.data.attributes.description_job_long || "",
        variant: "primary",
      };
    },
    contactHeroBlock() {
      return {
        hidden: false,
        title: this.data.attributes.form_header && this.data.attributes.form_header.title || "Jetzt mit deiner Karriere durchstarten!",
        text: this.data.attributes.form_header && this.data.attributes.form_header.text || "",
        variant: "primary",
      };
    },
  },
};
